import { ref } from 'vue'
import { toast } from 'vue-sonner'
import { useApi } from '../useApi.js'
import { usePostHog } from '../usePostHog.js'

/**
 * Composable pour la génération de PDF de devis
 * Limite: 60 lignes max
 */
export function useQuotePDFGeneration(quoteId, quote) {
  const exporting = ref(false)
  const showAmountModal = ref(false)
  const quoteAmountInput = ref('')
  const isFromEditor = ref(false)
  const { get: apiGet } = useApi()
  const { captureException } = usePostHog()

  const generateQuotePDF = async (onPreviewReady = null) => {
    const currentAmount = quote.value?.quote_amount
    
    if (!currentAmount || currentAmount === null || currentAmount === undefined) {
      quoteAmountInput.value = ''
      showAmountModal.value = true
      return null
    }
    
    const url = await generatePDFPreview(currentAmount)
    if (url && onPreviewReady) {
      onPreviewReady(url)
    }
    return url
  }

  const generatePDFPreview = async (amount, custom = false) => {
    exporting.value = true
    try {
      const params = {}
      if (amount) {
        params.amount = amount.toString()
      }
      if (custom) {
        params.custom = 'true'
      }
      const queryString = new URLSearchParams(params).toString()
      const url = `/api/exports/quotes/${quoteId}/pdf${queryString ? `?${queryString}` : ''}`
      
      const blob = await apiGet(url, {
        successMessage: 'Devis PDF généré avec succès',
        showSuccessToast: true,
        errorMessage: 'Erreur lors de la génération du PDF'
      })
      
      const urlBlob = window.URL.createObjectURL(blob)
      showAmountModal.value = false
      
      return urlBlob
    } catch (err) {
      // Capture error in PostHog with context
      captureException(err, {
        error_type: 'pdf_generation_error',
        quote_id: quoteId,
        amount: amount || null,
        custom: custom || false
      })
      
      console.error(err)
      throw err
    } finally {
      exporting.value = false
    }
  }

  return {
    exporting,
    showAmountModal,
    quoteAmountInput,
    isFromEditor,
    generateQuotePDF,
    generatePDFPreview
  }
}
